import mwrHttp from '@/utils/activityHttp'
import store from '@/store'
// const basePath = '/actApi/api/v1/wc'
// const basePath2 = '/actApi/account/api/v1'

const isDev = process.env.VUE_APP_ENV === 'dev'
let basePath = isDev ? '/minifire-wc/api/v1/wc' : 'https://wapi.miniworldplus.com:1443/minifire-wc/api/v1/wc'
let basePath2 = isDev ? '/minifire_account_server_os/api/v1' : 'https://wapi.miniworldplus.com:1443/minifire_account_server_os/api/v1'

if (process.env.VUE_APP_ENV === 'prod') {
  basePath = 'https://wapi.miniworldgame.com/minifire-wc/api/v1/wc'
  basePath2 = 'https://wapi.miniworldgame.com/minifire_account_server_os/api/v1'
}

  // basePath = 'https://wapi.miniworldgame.com/minifire-wc/api/v1/wc'
  // basePath2 = 'https://wapi.miniworldgame.com/minifire_account_server_os/api/v1'

export default {
  // 活动信息（余额、活动时间状态、应援统计）
  getActivityInfo: (params) => {
    return mwrHttp.post(`${basePath}/activity-info`, params)
  },

  //
// type GameTokenLoginReq struct {
// 	Uid       string `json:"uid"`
// 	TokenHash string `json:"tokenHash"`
// }
  gameTokenLogin: async (params) => {
    const res = await mwrHttp.post(`${basePath2}/game/gameTokenLogin`, params)
    console.log('loginByHashToken res', res)
    // 删除url的tokenHash和uid参数
    store.commit('SET_ACT_USER_INFO', {
      token: res.authorization,
      expireAt: res.expireAt,
      ...res.roleInfo,
    })
  },
  loginByMailCode: async (params) => {
    const res = await mwrHttp.post(`${basePath2}/game/gameMailLogin`, params)
    console.log('loginByMailCode res', res)
    store.commit('SET_ACT_USER_INFO', {
      token: res.authorization,
      expireAt: res.expireAt,
      ...res.roleInfo,
    })
    return res
  },

  sendMailCode: (params) => {
    return mwrHttp.post(`${basePath2}/game/sendGameMailVerifyCode`, params)
  },
  reportShare: (params) => {
    return mwrHttp.post(`${basePath}/share`, params)
  },
  // 分享活动
  share: (params) => {
    return mwrHttp.post(`${basePath2}/share/create`, params)
  },
  // 任务列表
  getTaskList: (params) => {
    return mwrHttp.post(`${basePath}/task-list`, params)
  },
  // 领取任务奖励
  receiveTaskReward: (params) => {
    return mwrHttp.post(`${basePath}/receive-task-reward`, params)
  },
  // 赛程列表
  getMatchList: (params) => {
    return mwrHttp.post(`${basePath}/match-list`, params)
  },
  // 送出应援
  placeCheer: (params) => {
    return mwrHttp.post(`${basePath}/place-cheer`, params)
  },
  // 应援记录
  getCheerRecord: (params) => {
    return mwrHttp.post(`${basePath}/cheer-record`, params)
  },
  getRewardRecord: (params = {}) => {
    return mwrHttp.post(`${basePath}/reward-record`, params)
  },
  // 里程碑奖励列表
  getMilestoneList: (params) => {
    return mwrHttp.post(`${basePath}/milestone-list`, params)
  },
  // 领取里程碑奖励
  receiveMilestone: (params) => {
    return mwrHttp.post(`${basePath}/receive-milestone`, params)
  },
  // 排行榜
  getRankList: (params) => {
    return mwrHttp.post(`${basePath}/rank-list`, params)
  },
  // 领取排行榜奖励
  receiveRankReward: (params) => {
    return mwrHttp.post(`${basePath}/receive-rank-reward`, params)
  },
}
